import { motion } from 'framer-motion';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledProduct, StyledProductText } from './style';
import { DailyBonusProductProps } from 'components/Popups/types';

export const PopupSingleProduct: React.FC<DailyBonusProductProps> = ({
  images,
  quantityDisplay,
  textColor,
}) => {
  return (
    <StyledProduct>
      <motion.img
        src={images.product}
        alt="product"
        animate={{ x: [1, -1.5, 1.5, 1], y: [1, 1.5, -1.5, 1] }}
        transition={{ repeat: Infinity, duration: 2 }}
      />
      <StyledProductText color={textColor}>
        {images.productPrefix && (
          <img src={images.productPrefix} alt="prefix" />
        )}
        <div className={'quantity-wrapper'}>
          <AutoTextSize
            maxFontSizePx={40}
            minFontSizePx={4}
            as="div"
            className="quantity"
            mode="oneline"
          >
            {quantityDisplay}
          </AutoTextSize>
        </div>
      </StyledProductText>
    </StyledProduct>
  );
};
